module.exports = __webpack_public_path__ + "img/remote.cec3d0f7.svg";